'use strict';

/* Controllers */

app.controller('DrinkReceiptController', ['$scope', '$rootScope', '$location', '$timeout', 'Drink', 'User', 'Cart', 'Venue', 'Router', 
    function ($scope, $rootScope, $location, $timeout, Drink, User, Cart, Venue, Router) {

    	// pass service to scope
    	$scope.User  = User;

    	// init scope vars
    	$scope.selectedUser     = $rootScope.globals.selectedUser;
    	$scope.selectedVenue    = $rootScope.globals.selectedVenue;
    	$scope.selectedDrink    = $rootScope.globals.selectedDrink;
    	$scope.currency_symbol  = $rootScope.globals.selectedVenue.currency_symbol+' ';

        $scope.venue_fee = Venue.getServiceFee();
        $scope.discount  = Venue.getDiscount();
    	$scope.total     = Cart.getTotal();
        $scope.selected_drink_price = Drink.getSelectedDrinkPrice();
        

        // colorize drink images
        Caman('.list-group-item.drink img', function () {
            this.colorize('#ffffff', 100).render();
        });


        /**
         * clear cart and redirect home
         */
        $scope.returnHome = function(){
            $timeout(function(){
                Cart.clearCart();
            }, 100);
            
            $location.path('/');
        }
    }]);